import { translate } from '../../../../../Services/translation';
import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  removeCampaignCode,
  setCampaignCode,
  submitCampaignCode,
} from '../../../../../Actions/Checkout.action';
import CheckoutError from '../../../other/CheckoutError';
import { cn } from '../../../../../Utils/cn';

const CheckoutCartCampaignCode = ({ checkout }) => {
  const { payload, errors } = checkout || {};
  const { isBusinessCustomer, discountCode, usedDiscountCodes } = payload || {};

  const inputRef = useRef(null);
  const [active, setActive] = useState(false);
  const dispatch = useDispatch();

  const value = typeof discountCode === 'string' ? discountCode : '';

  const onToggle = useCallback(() => setActive((v) => !v), []);
  const onChange = useCallback(
    (event) => dispatch(setCampaignCode(event.target.value)),
    [dispatch]
  );
  const onSubmit = useCallback(
    (event) => {
      event.preventDefault();
      dispatch(submitCampaignCode());
      dispatch(setCampaignCode(''));
    },
    [dispatch]
  );

  const onRemoveCode = useCallback(
    (codeToRemove) => {
      dispatch(removeCampaignCode(codeToRemove));
    },
    [dispatch]
  );

  useEffect(() => {
    if (active && inputRef?.current) {
      inputRef.current.focus();
      inputRef.current.select?.();
    }
  }, [active]);

  if (isBusinessCustomer) {
    return null;
  }

  return (
    <div className="mb-4">
      <button
        className="link-inverted inline-flex items-center gap-2"
        onClick={onToggle}
      >
        {translate('checkout.askcampaigncode')}
        <span
          className={cn(
            'icon -m-1 rotate-90 overflow-hidden',
            active && '-rotate-90'
          )}
        >
          chevron_right
        </span>
      </button>
      <form
        className={cn('mt-2', !active && 'hidden')}
        onSubmit={onSubmit}
        noValidate
      >
        <div className="flex gap-2">
          <input
            className="input"
            placeholder={translate('checkout.campaigncode')}
            value={value}
            onChange={onChange}
            ref={inputRef}
          />
          <button type="submit" className="button">
            {translate('checkout.usecampaigncode')}
          </button>
        </div>
        <CheckoutError
          errors={errors?.DiscountCode}
          className="body-sm text-error mt-1"
        />
      </form>
      {!!usedDiscountCodes?.length && (
        <div className="mt-4 flex items-center gap-2">
          <div className="body">
            {translate('checkout.used_discount_codes')}:
          </div>
          {usedDiscountCodes.map((code, index) => (
            <button
              className="border-border-primary body-sm body_bold leading-base flex items-center gap-2 rounded-2xl border px-3 py-1"
              onClick={() => onRemoveCode(code)}
              label={translate('checkout.cart.delete_campaign_code')}
              key={index}
            >
              <span>{code}</span>
              <span className="icon -m-0.5 !text-[1rem]">close</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CheckoutCartCampaignCode;
